import { firstValueFrom } from 'rxjs';
import { MpsUserService } from '../services/mps-user.service';
import { User } from '../../app/modules/_models/user';

export function mpsFetchUser(userService: MpsUserService) {
  return async (): Promise<User | undefined> => {
    try {
      if (!window.location.href.includes('oauth2/token') && !window.location.href.includes('login?error=')) {
        const userPromise = firstValueFrom(userService.fetchUser());
        return await userPromise;
      }

      return undefined;
    } catch (_error) {
      return undefined;
    }
  };
}
